
import React, { useState, useEffect, useContext } from "react";
import { plantCurveApi } from "../../../../../../../api/Api";
import EnergyChartPower from "../../../../../../../components/charts/energy_reporting/EnergyChartPower";
import { AppThemeContext } from "../../../../../../../context/AppThemeContext";
import { useTheme } from "@emotion/react";
import AppModal from "../../../../../../../components/AppModal";
import InvverterFullSize from "../../../../../../../components/inverter/InvverterFullSize";

// Utility function to format date as 'YYYY-MM-DD HH:mm'
const formatDateTime = (date) => {
    const pad = (num) => String(num).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export default function PlantEnergyData() {
    const { PrimaryColor } = useContext(AppThemeContext);
    const { palette } = useTheme();
    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    const now = new Date(); // Current date and time

    // Default start and end dates
    const initialStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 5, 0); // 5:00 AM
    const initialEndDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 20, 0); // 8:00 PM

    const [startDate, setStartDate] = useState(formatDateTime(initialStartDate));
    const [endDate, setEndDate] = useState(formatDateTime(initialEndDate));
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [chartLabels, setChartLabels] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [gradientFill, setGradientFill] = useState(null);

    const credentials = {
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        PASS_KEY: localStorage.getItem("KEY") || "xyz",
        LOC_CODE: localStorage.getItem("LCODE") || "",
        DT1: startDate,
        DT2: endDate,
        WEB_KEY: "WEBXYZ321",
    };

    // Fetch log data from the API
    const fetchLogData = async () => {
        setLoading(true);
        setError(null);

        try {
            const res = await plantCurveApi(credentials);

            if (res?.data && Array.isArray(res.data)) {
                const labels = res.data.map((item) => item.datet);

                const datasets = [
                    {
                        label: "Plant Total (kW)",
                        data: res.data.map((item) => parseFloat(item.TOT_INV_KW) || 0),
                        borderColor: "red",
                        backgroundColor: gradientFill,
                        tension: 0.3,
                        fill: true,
                        borderWidth: 2,
                        pointRadius: 0.9,
                        pointHoverRadius: 1,
                    },
                    // Add other datasets here as needed
                ];

                setChartLabels(labels);
                setChartData(datasets);
            } else {
                // console.warn("Empty or Invalid API Response Data");
                setChartLabels([]);
                setChartData([]);
            }
        } catch (err) {
            // console.error("API Error:", err);
            setError("Failed to fetch data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const createGradientShade = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, palette.primary.main);
        gradient.addColorStop(1, "rgba(255, 255, 255, 0)");
        return gradient;
    };

    useEffect(() => {
        setGradientFill(createGradientShade());
    }, [palette.primary.main]);

    // Fetch data on component mount and set up 30-second interval
    useEffect(() => {
        fetchLogData(); // Fetch data initially

        // Set up interval for 30-second refresh
        const interval = setInterval(() => {
            fetchLogData();
        }, 300000); // 30 seconds

        // Clean up interval on component unmount
        return () => clearInterval(interval);
    }, [startDate, endDate, gradientFill]);

    const handleStartDateChange = (value) => {
        const formattedDate = formatDateTime(new Date(value));
        setStartDate(formattedDate);
    };

    const handleEndDateChange = (value) => {
        const formattedDate = formatDateTime(new Date(value));
        setEndDate(formattedDate);
    };

    return (

        <>
            <div className="row">

                <div className="col-md-12">

                    <div style={{
                        marginBottom: "5px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "16px",
                    }}>
                        {/* Left-side title */}
                        <div style={{ marginLeft: "7px", fontSize: "10px" }}>
                            Plant [kW]
                        </div>

                        {/* Right-side date pickers */}
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}>
                            <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                <span>From:</span>
                                <input
                                    type="datetime-local"
                                    value={startDate.replace(" ", "T")}
                                    onChange={(e) => handleStartDateChange(e.target.value)}
                                    style={{
                                        padding: "2px 8px",
                                        borderRadius: "14px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </label>
                            <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                <span>To:</span>
                                <input
                                    type="datetime-local"
                                    value={endDate.replace(" ", "T")}
                                    onChange={(e) => handleEndDateChange(e.target.value)}
                                    style={{
                                        padding: "2px 8px",
                                        borderRadius: "14px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </label>
                        </div>
                    </div>

                    {/* {loading && <p>Loading chart data...</p>}
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    {!loading && !error && (
                        <>
                            <InvverterFullSize title={``} onFullScreen={handleOpenMix} />
                            <EnergyChartPower labels={chartLabels} data={chartData} title={``} />
                            <AppModal open={OpenMix} handleClose={handleCloseMix}>
                                <EnergyChartPower labels={chartLabels} data={chartData} title={``} />
                            </AppModal>
                        </>
                    )} */}

                    <EnergyChartPower labels={chartLabels} data={chartData} title={``} />
                </div>
                
            </div>

        </>


    );
}
